import { useEffect, useState } from 'react';
import { API_URL } from '../../lib/api';
import { facturation, type FactureEspace } from '../../lib/dossiers';

const euros = (n: number) => n.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

/**
 * « Factures » de « Mes abonnements » (29/10/2026, lot 4) : les factures et
 * avoirs émis par Vanna pour l'espace — le seul endroit où le client les
 * retrouve, les reçus Stripe étant désactivés. Propriétaire et
 * administrateurs seulement.
 */
export function FacturesEspace({ spaceId }: { spaceId: string }) {
  const [factures, setFactures] = useState<FactureEspace[] | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    setFactures(null);
    facturation
      .factures(spaceId)
      .then(setFactures)
      .catch(() => setErreur('Les factures n’ont pas pu être chargées.'));
  }, [spaceId]);

  return (
    <section id="factures" className="dos-recap" aria-labelledby="factures-titre">
      <h2 id="factures-titre" className="dos-section">
        Factures
      </h2>
      {erreur ? (
        <p className="dos-erreur" role="alert">
          {erreur}
        </p>
      ) : !factures ? (
        <p role="status">Chargement…</p>
      ) : factures.length === 0 ? (
        <p className="dos-aide">Aucune facture pour cet espace pour le moment.</p>
      ) : (
        <ul className="dos-choix dos-choix--liste">
          {factures.map((f) => (
            <li key={f.id} className="dos-option">
              <span>
                <strong>
                  {f.kind === 'AVOIR' ? 'Avoir' : 'Facture'} {f.number}
                </strong>
                <small>
                  {' '}
                  du {new Date(f.issuedAt).toLocaleDateString('fr-FR')}
                  {f.creditedInvoice ? ` — corrige la facture ${f.creditedInvoice.number}` : ''}
                  {f.status === 'REMBOURSEE' ? ' — remboursée' : ''}
                </small>
              </span>
              <small>
                {euros(f.amountTtc)} TTC ({euros(f.amountHt)} HT)
              </small>
              {f.pdfDisponible ? (
                <a
                  className="btn btn-secondaire"
                  href={`${API_URL}/espace/billing/factures/${encodeURIComponent(f.id)}/pdf?spaceId=${encodeURIComponent(spaceId)}`}
                >
                  Télécharger le PDF
                </a>
              ) : (
                <small>PDF en préparation</small>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
